import $ from 'cash-dom';

export default () => {
  const $buttons = $('.js-pricing-change');
  const $line = $('.js-pricing-line');
  const $prices = $('.js-pricing-price');
  const $support = $('.js-pricing-support');
  const $button = $('.js-pricing-button');

  $buttons.on('change', (e) => {
    const $this = $(e.currentTarget);
    const value = $this.prop('value');
    const buttonText = $this.data('button');

    $line.removeClass('is-to10 is-to100 is-to300 is-more300');
    $line.addClass(`is-${value}`);

    $prices.each((index, item) => {
      const $item = $(item);
      const classItem = `pricing-line__item--${value}`;

      if ($item.hasClass(classItem)) {
        $prices.removeClass('is-active');
        $item.addClass('is-active');
      }
    });

    if (value === 'to10') {
      $support.removeClass('is-active');
    } else {
      $support.addClass('is-active');
    }

    $button.text(buttonText);
  });
};
